import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import { Card, CardContent } from "@material-ui/core"

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';

import { Layout } from '../../layouts/private/Private';

import DependenciaAdministrativaFilter from '../../forms/DependenciaAdministrativa/DependenciaAdministrativaFilter';
import Filters from '../../components/Filters/Filters';

import InscricoesPorEdicao from './InscricoesPorEdicao';
import InscricoesPorData from './InscricoesPorData';

import Cache from './Cache';

import { currentDateTime } from "../../helper/DateHelper";

export class QuantitativoInscricoes extends Component {
    constructor(props){
        super(props);
        this.state = {
            count: 0,
            ultimaChamadaGeral: '',
        }
    }

    setDependenciaAdministrativaFilter = d => this.DependenciaAdministrativaFilter = d;
    setInscricoesPorEdicao = e => this.InscricoesPorEdicao = e;
    setInscricoesPorData = d => this.InscricoesPorData = d;

    // FILTROS
    ApplyFilters = () => {
        const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;
        
        this.InscricoesPorEdicao.setState({
            filters: {
                adminDep: filtersDepAdm.adminDep ?? '',
            }
        }, () => this.InscricoesPorEdicao.ApplyFilters(true))
        
        this.InscricoesPorData.setState({
            filters: {
                adminDep: filtersDepAdm.adminDep ?? '',
            }
        }, () => this.InscricoesPorData.ApplyFilters(true))

        this.setState({ 
            count: filtersDepAdm.adminDep ? this.state.count + 1 : this.state.count, 
        })
    }

    refreshAll () {                
        this.setState({
            ultimaChamadaGeral: currentDateTime(this.props.contexts),
        }, () => {
            this.InscricoesPorEdicao.ApplyFilters(true);
            this.InscricoesPorData.ApplyFilters(true);
        })
    }
    
    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.DependenciaAdministrativaFilter.setState({
            filters: {
                adminDep: '',
            }
        })
    }

    handleCountFilters = () => this.state.count;

    componentDidMount () { this.props.loadPeriodos() }

    render() {
        const pageName = 'Inscrições';
        const links = [
            { 
                path: null, 
                name: 'Relatórios' 
            }
        ];

        return(
            <Layout>
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={pageName} />
                    </Grid>
                </Grid>

                <Title>
                    {pageName}
                    <Cache label={`Atualizar Tudo`} ultimaAtualizacao={this.state.ultimaChamadaGeral} action={() => this.refreshAll()} />
                </Title>

                <Filters
                    handleFilter={this.ApplyFilters}
                    handleFilterClear={this.handleFilterClear}
                    countFilters={this.handleCountFilters}
                >
                    <Grid item container spacing={3}>
                        <DependenciaAdministrativaFilter
                            parentRef={this.setDependenciaAdministrativaFilter}
                            withPublicGroup={true}
                        />
                    </Grid>
                </Filters>

                <Card style={{ marginTop: 20, marginBottom: 20 }}>
                    <CardContent style={{ padding: 20, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
                        <InscricoesPorEdicao parentRef={this.setInscricoesPorEdicao} contexts={this.props.contexts} />
                    </CardContent>
                </Card>

                <Card style={{ marginTop: 20, marginBottom: 20 }}>
                    <CardContent style={{ padding: 20, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
                        <InscricoesPorData parentRef={this.setInscricoesPorData} />
                    </CardContent>
                </Card>
            </Layout>
        )
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QuantitativoInscricoes));